import * as API from "@/services/API";

const API_ENDPOINT = "/admin/roles";

export default {
  getAll() {
    return API.apiClient.get(API_ENDPOINT + "/all");
  },
};
